import React from "react";
import swal from "sweetalert";
import { useSave } from "seed/gql";
import { SAVE_PARTICIPANT_ROLE } from "seed/gql/queries";
import l from "components/util/l";
import View from "components/presentation/settings/roles/RoleFormView.view";


function RoleFormCreate({ flowId, reqRoles, onClose }) {

  const [callSave, reqSave] = useSave(SAVE_PARTICIPANT_ROLE, {
    onCompleted: () => {
      onClose();
      reqRoles.refetch();
    },
    onError: (error) => {
      swal("Error", l("No fue posible crear el rol%PA063"), "error");
      console.error("Error al crear el rol", error);
    },
  });

  const onSubmit = (values) => {
    const { name } = values;
    if (!name) {
      swal("Error", l("El nombre es requerido%PA064"), "error");
      return;
    }
    callSave({
      name: name,
      uiSettings: {},
      settings: {},
      flow: flowId,
    });
  }

  return <View onSubmit={onSubmit} />;
}


export default RoleFormCreate;